(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["author-rise-submission"] && !Shopify.designMode) return;
  try {
    const arSubmissionForm=document.getElementById('AuthorRiseSubmissionForm');
if(arSubmissionForm){
  const type=arSubmissionForm.querySelector('#ARSubmissionType');
  const link=arSubmissionForm.querySelector('#ARSubmissionLink');
  const body=arSubmissionForm.querySelector('#ARSubmissionBody');
  const name=arSubmissionForm.querySelector('#ARSubmissionName');
  const title=arSubmissionForm.querySelector('#ARSubmissionTitle');
  if(type&&link){
    const setLinkRequirement=()=>{link.required=['Social media post','Video or podcast','Article or newsletter link'].includes(type.value);};
    type.addEventListener('change',setLinkRequirement);
    setLinkRequirement();
    window.addEventListener('pageshow',setLinkRequirement);
  }
  for(const field of [name,title,body]){
    if(field){field.addEventListener('change',()=>{field.value=field.value.trim();});}
  }
  const message=arSubmissionForm.querySelector('.ar-submission-message');
  if(message){message.focus();}
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-art-controls"] && !Shopify.designMode) return;
  try {
    function initializeArtControls(root) {
  root.querySelectorAll('[data-art-controls]').forEach(controls => {
    if (controls.dataset.initialized) return;
    const grid = controls.closest('[data-creations-browser]').querySelector('#pp-gallery-products');
    if (!grid) return;
    controls.dataset.initialized = 'true';
    const form = controls.querySelector('form');
    const cards = [...grid.querySelectorAll('[data-art-item]')].map((node,index) => ({
      node,index,id:node.dataset.artId,title:node.dataset.artTitle,
      price:Number(node.dataset.artPrice),date:Number(node.dataset.artDate),
      variants:JSON.parse(node.dataset.artVariants)
    }));
    const stocks = [...form.querySelectorAll('[name="art_availability"]')];
    const min = form.elements.art_price_min;
    const max = form.elements.art_price_max;
    const sort = form.elements.art_sort_by;
    const button = form.querySelector('button[type="submit"]');
    const error = controls.querySelector('[data-art-error]');
    const count = controls.querySelector('[data-art-count]');
    const originalSort = sort.value;
    const highest = Math.max(0,...cards.flatMap(card=>card.variants.map(v=>v.price))) / 100;
    min.max = max.max = String(highest);
    max.placeholder = String(highest);
    stocks.forEach(input => {
      const total=cards.filter(card=>card.variants.some(v=>v.available) === (input.value==='1')).length;
      controls.querySelector('[data-art-stock-count="'+input.value+'"]').textContent=total;
      input.disabled=total===0;
    });
    let rankings;
    async function getRankings() {
      if (rankings) return rankings;
      const ranks = new Map();
      let url = new URL(controls.dataset.orderUrl,location.origin);
      while (url) {
        const response=await fetch(url,{credentials:'same-origin'});
        if (!response.ok) throw new Error('Art order unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const order=doc.querySelector('[data-gift-order]');
        if (!order) throw new Error('Art order missing');
        order.querySelectorAll('[data-gift-id]').forEach(item=>{
          if (!ranks.has(item.dataset.giftId)) ranks.set(item.dataset.giftId,ranks.size);
        });
        const next=order.dataset.next;
        url=next ? new URL(next,location.origin) : null;
        if (url) {url.searchParams.set('view','positive-pen-gift-order');url.searchParams.set('sort_by','best-selling');}
      }
      rankings=ranks;
      return ranks;
    }
    function readUrl() {
      const params=new URLSearchParams(location.search);
      stocks.forEach(input=>input.checked=params.getAll('art_availability').includes(input.value)&&!input.disabled);
      min.value=params.get('art_price_min')||'';
      max.value=params.get('art_price_max')||'';
      const selected=params.get('art_sort_by');
      sort.value=[...sort.options].some(option=>option.value===selected)?selected:originalSort;
    }
    function writeUrl() {
      const url=new URL(location.href);
      ['art_availability','art_price_min','art_price_max','art_sort_by'].forEach(key=>url.searchParams.delete(key));
      stocks.filter(input=>input.checked).forEach(input=>url.searchParams.append(input.name,input.value));
      if(min.value!=='')url.searchParams.set(min.name,min.value);
      if(max.value!=='')url.searchParams.set(max.name,max.value);
      if(sort.value!==originalSort)url.searchParams.set(sort.name,sort.value);
      url.hash='all-products';
      history.replaceState(null,'',url);
    }
    async function apply(updateUrl) {
      error.hidden=true;
      max.setCustomValidity(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)?controls.dataset.rangeError:'');
      if (!form.reportValidity()) return;
      button.disabled=true;
      try {
        const rank=sort.value==='best-selling'?await getRankings():null;
        const stock=stocks.filter(input=>input.checked).map(input=>input.value);
        const low=min.value===''?0:Number(min.value)*100;
        const high=max.value===''?Infinity:Number(max.value)*100;
        const ordered=[...cards].sort((a,b)=>{
          switch(sort.value) {
            case 'title-ascending':return a.title.localeCompare(b.title);
            case 'title-descending':return b.title.localeCompare(a.title);
            case 'price-ascending':return a.price-b.price||a.index-b.index;
            case 'price-descending':return b.price-a.price||a.index-b.index;
            case 'created-ascending':return a.date-b.date||a.index-b.index;
            case 'created-descending':return b.date-a.date||a.index-b.index;
            case 'best-selling':return (rank.get(a.id)??Infinity)-(rank.get(b.id)??Infinity)||a.index-b.index;
            default:return a.index-b.index;
          }
        });
        let shown=0;
        ordered.forEach(card=>{
          const inStock=card.variants.some(v=>v.available);
          const stockMatch=stock.length===0||stock.includes(inStock?'1':'0');
          const priceMatch=card.variants.some(v=>v.price>=low&&v.price<=high);
          card.node.hidden=!(stockMatch&&priceMatch);
          if(!card.node.hidden)shown++;
          grid.append(card.node);
        });
        count.textContent=controls.dataset.countTemplate.replace('__shown__',shown).replace('__total__',cards.length);
        if(updateUrl)writeUrl();
      } catch (failure) {
        error.textContent=controls.dataset.error;
        error.hidden=false;
      } finally {button.disabled=false;}
    }
    form.addEventListener('submit',event=>{event.preventDefault();apply(true);});
    min.addEventListener('input',()=>max.setCustomValidity(''));
    max.addEventListener('input',()=>max.setCustomValidity(''));
    controls.querySelector('[data-art-reset]').addEventListener('click',event=>{
      event.preventDefault();form.reset();sort.value=originalSort;max.setCustomValidity('');apply(true);
    });
    window.addEventListener('popstate',()=>{readUrl();apply(false);});
    readUrl();apply(false);
  });
}
initializeArtControls(document);
document.addEventListener('shopify:section:load',event=>initializeArtControls(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-gallery-controls"] && !Shopify.designMode) return;
  try {
    function initializePenGalleryControls(root) {
  root.querySelectorAll('[data-pen-gallery-controls]').forEach(controls => {
    if (controls.dataset.initialized) return;
    const grid = controls.closest('[data-creations-browser]').querySelector('#pp-gallery-products');
    if (!grid) return;
    controls.dataset.initialized = 'true';
    const form = controls.querySelector('form');
    const cards = [...grid.querySelectorAll('[data-art-item]')].map((node,index) => ({
      node,index,id:node.dataset.artId,title:node.dataset.artTitle,
      price:Number(node.dataset.artPrice),date:Number(node.dataset.artDate),
      variants:JSON.parse(node.dataset.artVariants)
    }));
    let category='all';
    const categoryButtons=[...controls.querySelectorAll('[data-gallery-category]')];
    const empty=controls.closest('[data-creations-browser]').querySelector('[data-gallery-empty]');
    const stocks = [...form.querySelectorAll('[name="art_availability"]')];
    const min = form.elements.art_price_min;
    const max = form.elements.art_price_max;
    const sort = form.elements.art_sort_by;
    const button = form.querySelector('button[type="submit"]');
    const error = controls.querySelector('[data-art-error]');
    const count = controls.querySelector('[data-art-count]');
    const originalSort = sort.value;
    const highest = Math.max(0,...cards.flatMap(card=>card.variants.map(v=>v.price))) / 100;
    min.max = max.max = String(highest);
    max.placeholder = String(highest);
    stocks.forEach(input => {
      const total=cards.filter(card=>card.variants.some(v=>v.available) === (input.value==='1')).length;
      controls.querySelector('[data-art-stock-count="'+input.value+'"]').textContent=total;
      input.disabled=total===0;
    });
    let rankings;
    async function getRankings() {
      if (rankings) return rankings;
      const ranks = new Map();
      let url = new URL(controls.dataset.orderUrl,location.origin);
      while (url) {
        const response=await fetch(url,{credentials:'same-origin'});
        if (!response.ok) throw new Error('Art order unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const order=doc.querySelector('[data-gift-order]');
        if (!order) throw new Error('Art order missing');
        order.querySelectorAll('[data-gift-id]').forEach(item=>{
          if (!ranks.has(item.dataset.giftId)) ranks.set(item.dataset.giftId,ranks.size);
        });
        const next=order.dataset.next;
        url=next ? new URL(next,location.origin) : null;
        if (url) {url.searchParams.set('view','positive-pen-gift-order');url.searchParams.set('sort_by','best-selling');}
      }
      rankings=ranks;
      return ranks;
    }
    function readUrl() {
      const params=new URLSearchParams(location.search);
      const chosen=params.get('art_category');
      category=categoryButtons.some(btn=>btn.dataset.galleryCategory===chosen)?chosen:'all';
      categoryButtons.forEach(btn=>btn.setAttribute('aria-pressed',String(btn.dataset.galleryCategory===category)));
      stocks.forEach(input=>input.checked=params.getAll('art_availability').includes(input.value)&&!input.disabled);
      min.value=params.get('art_price_min')||'';
      max.value=params.get('art_price_max')||'';
      const selected=params.get('art_sort_by');
      sort.value=[...sort.options].some(option=>option.value===selected)?selected:originalSort;
    }
    function writeUrl() {
      const url=new URL(location.href);
      ['art_availability','art_price_min','art_price_max','art_sort_by','art_category'].forEach(key=>url.searchParams.delete(key));
      stocks.filter(input=>input.checked).forEach(input=>url.searchParams.append(input.name,input.value));
      if(min.value!=='')url.searchParams.set(min.name,min.value);
      if(max.value!=='')url.searchParams.set(max.name,max.value);
      if(sort.value!==originalSort)url.searchParams.set(sort.name,sort.value);
      if(category!=='all')url.searchParams.set('art_category',category);
      url.hash='all-products';
      history.replaceState(null,'',url);
    }
    async function apply(updateUrl) {
      error.hidden=true;
      max.setCustomValidity(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)?controls.dataset.rangeError:'');
      if (!form.reportValidity()) return;
      button.disabled=true;
      try {
        const rank=sort.value==='best-selling'?await getRankings():null;
        const stock=stocks.filter(input=>input.checked).map(input=>input.value);
        const low=min.value===''?0:Number(min.value)*100;
        const high=max.value===''?Infinity:Number(max.value)*100;
        const ordered=[...cards].sort((a,b)=>{
          switch(sort.value) {
            case 'title-ascending':return a.title.localeCompare(b.title);
            case 'title-descending':return b.title.localeCompare(a.title);
            case 'price-ascending':return a.price-b.price||a.index-b.index;
            case 'price-descending':return b.price-a.price||a.index-b.index;
            case 'created-ascending':return a.date-b.date||a.index-b.index;
            case 'created-descending':return b.date-a.date||a.index-b.index;
            case 'best-selling':return (rank.get(a.id)??Infinity)-(rank.get(b.id)??Infinity)||a.index-b.index;
            default:return a.index-b.index;
          }
        });
        let shown=0;
        ordered.forEach(card=>{
          const inStock=card.variants.some(v=>v.available);
          const stockMatch=stock.length===0||stock.includes(inStock?'1':'0');
          const priceMatch=card.variants.some(v=>v.price>=low&&v.price<=high);
          const categoryMatch=category==='all'||card.node.dataset.artCategory===category;
          card.node.hidden=!(stockMatch&&priceMatch&&categoryMatch);
          if(!card.node.hidden)shown++;
          grid.append(card.node);
        });
        count.textContent=controls.dataset.countTemplate.replace('__shown__',shown).replace('__total__',cards.length);
        if(empty)empty.hidden=shown!==0;
        if(updateUrl)writeUrl();
      } catch (failure) {
        error.textContent=controls.dataset.error;
        error.hidden=false;
      } finally {button.disabled=false;}
    }
    form.addEventListener('submit',event=>{event.preventDefault();apply(true);});
    min.addEventListener('input',()=>max.setCustomValidity(''));
    max.addEventListener('input',()=>max.setCustomValidity(''));
    controls.querySelector('[data-art-reset]').addEventListener('click',event=>{
      event.preventDefault();category='all';categoryButtons.forEach(btn=>btn.setAttribute('aria-pressed',String(btn.dataset.galleryCategory==='all')));form.reset();sort.value=originalSort;max.setCustomValidity('');apply(true);
    });
    categoryButtons.forEach(btn=>btn.addEventListener('click',()=>{category=btn.dataset.galleryCategory;categoryButtons.forEach(other=>other.setAttribute('aria-pressed',String(other===btn)));apply(true);}));
    window.addEventListener('popstate',()=>{readUrl();apply(false);});
    readUrl();apply(false);
  });
}
initializePenGalleryControls(document);
document.addEventListener('shopify:section:load',event=>initializePenGalleryControls(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-gift-controls"] && !Shopify.designMode) return;
  try {
    function initializeGiftControls(root) {
  root.querySelectorAll('[data-gift-controls]').forEach(controls => {
    if (controls.dataset.initialized) return;
    const grid = controls.closest('[data-creations-browser]').querySelector('#pp-gallery-products');
    if (!grid) return;
    controls.dataset.initialized = 'true';
    const form = controls.querySelector('form');
    const cards = [...grid.querySelectorAll('[data-gift-item]')].map((node,index) => ({
      node,index,id:node.dataset.giftId,title:node.dataset.giftTitle,
      price:Number(node.dataset.giftPrice),date:Number(node.dataset.giftDate),
      variants:JSON.parse(node.dataset.giftVariants)
    }));
    const stocks = [...form.querySelectorAll('[name="gift_availability"]')];
    const min = form.elements.gift_price_min;
    const max = form.elements.gift_price_max;
    const sort = form.elements.gift_sort_by;
    const button = form.querySelector('button[type="submit"]');
    const error = controls.querySelector('[data-gift-error]');
    const count = controls.querySelector('[data-gift-count]');
    const originalSort = sort.value;
    const highest = Math.max(0,...cards.flatMap(card=>card.variants.map(v=>v.price))) / 100;
    min.max = max.max = String(highest);
    max.placeholder = String(highest);
    stocks.forEach(input => {
      const total=cards.filter(card=>card.variants.some(v=>v.available) === (input.value==='1')).length;
      controls.querySelector('[data-gift-stock-count="'+input.value+'"]').textContent=total;
      input.disabled=total===0;
    });
    let rankings;
    async function getRankings() {
      if (rankings) return rankings;
      const ranks = new Map();
      let url = new URL(controls.dataset.orderUrl,location.origin);
      while (url) {
        const response=await fetch(url,{credentials:'same-origin'});
        if (!response.ok) throw new Error('Gift order unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const order=doc.querySelector('[data-gift-order]');
        if (!order) throw new Error('Gift order missing');
        order.querySelectorAll('[data-gift-id]').forEach(item=>{
          if (!ranks.has(item.dataset.giftId)) ranks.set(item.dataset.giftId,ranks.size);
        });
        const next=order.dataset.next;
        url=next ? new URL(next,location.origin) : null;
        if (url) {url.searchParams.set('view','positive-pen-gift-order');url.searchParams.set('sort_by','best-selling');}
      }
      rankings=ranks;
      return ranks;
    }
    function readUrl() {
      const params=new URLSearchParams(location.search);
      stocks.forEach(input=>input.checked=params.getAll('gift_availability').includes(input.value)&&!input.disabled);
      min.value=params.get('gift_price_min')||'';
      max.value=params.get('gift_price_max')||'';
      const selected=params.get('gift_sort_by');
      sort.value=[...sort.options].some(option=>option.value===selected)?selected:originalSort;
    }
    function writeUrl() {
      const url=new URL(location.href);
      ['gift_availability','gift_price_min','gift_price_max','gift_sort_by'].forEach(key=>url.searchParams.delete(key));
      stocks.filter(input=>input.checked).forEach(input=>url.searchParams.append(input.name,input.value));
      if(min.value!=='')url.searchParams.set(min.name,min.value);
      if(max.value!=='')url.searchParams.set(max.name,max.value);
      if(sort.value!==originalSort)url.searchParams.set(sort.name,sort.value);
      url.hash='all-products';
      history.replaceState(null,'',url);
    }
    async function apply(updateUrl) {
      error.hidden=true;
      max.setCustomValidity(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)?controls.dataset.rangeError:'');
      if (!form.reportValidity()) return;
      button.disabled=true;
      try {
        const rank=sort.value==='best-selling'?await getRankings():null;
        const stock=stocks.filter(input=>input.checked).map(input=>input.value);
        const low=min.value===''?0:Number(min.value)*100;
        const high=max.value===''?Infinity:Number(max.value)*100;
        const ordered=[...cards].sort((a,b)=>{
          switch(sort.value) {
            case 'title-ascending':return a.title.localeCompare(b.title);
            case 'title-descending':return b.title.localeCompare(a.title);
            case 'price-ascending':return a.price-b.price||a.index-b.index;
            case 'price-descending':return b.price-a.price||a.index-b.index;
            case 'created-ascending':return a.date-b.date||a.index-b.index;
            case 'created-descending':return b.date-a.date||a.index-b.index;
            case 'best-selling':return (rank.get(a.id)??Infinity)-(rank.get(b.id)??Infinity)||a.index-b.index;
            default:return a.index-b.index;
          }
        });
        let shown=0;
        ordered.forEach(card=>{
          const inStock=card.variants.some(v=>v.available);
          const stockMatch=stock.length===0||stock.includes(inStock?'1':'0');
          const priceMatch=card.variants.some(v=>v.price>=low&&v.price<=high);
          card.node.hidden=!(stockMatch&&priceMatch);
          if(!card.node.hidden)shown++;
          grid.append(card.node);
        });
        count.textContent=controls.dataset.countTemplate.replace('__shown__',shown).replace('__total__',cards.length);
        if(updateUrl)writeUrl();
      } catch (failure) {
        error.textContent=controls.dataset.error;
        error.hidden=false;
      } finally {button.disabled=false;}
    }
    form.addEventListener('submit',event=>{event.preventDefault();apply(true);});
    min.addEventListener('input',()=>max.setCustomValidity(''));
    max.addEventListener('input',()=>max.setCustomValidity(''));
    controls.querySelector('[data-gift-reset]').addEventListener('click',event=>{
      event.preventDefault();form.reset();sort.value=originalSort;max.setCustomValidity('');apply(true);
    });
    window.addEventListener('popstate',()=>{readUrl();apply(false);});
    readUrl();apply(false);
  });
}
initializeGiftControls(document);
document.addEventListener('shopify:section:load',event=>initializeGiftControls(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-library-shuffle"] && !Shopify.designMode) return;
  try {
    function shufflePenLibraryCards(root) {
  root.querySelectorAll('[data-library-shuffle]').forEach(grid => {
    if (grid.dataset.shuffleReady) return;
    grid.dataset.shuffleReady = 'true';
    const cards = Array.from(grid.children);
    if (cards.length < 2) return;
    const cardId = card => {
      const entry = card.matches('[data-library-entry]') ? card : card.querySelector('[data-library-entry]');
      return entry ? entry.dataset.libraryId : card.textContent.trim();
    };
    const signature = items => JSON.stringify(items.map(cardId));
    const key = 'positive-pen-library-order:' + location.pathname + ':' + (new URLSearchParams(location.search).get('page') || '1') + ':' + grid.dataset.libraryShuffle;
    let previous = signature(cards);
    try { previous = sessionStorage.getItem(key) || previous; } catch {}
    for (let i = cards.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }
    if (signature(cards) === previous) cards.push(cards.shift());
    cards.forEach(card => grid.appendChild(card));
    try { sessionStorage.setItem(key, signature(cards)); } catch {}
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => shufflePenLibraryCards(document));
} else {
  shufflePenLibraryCards(document);
}
document.addEventListener('shopify:section:load', event => shufflePenLibraryCards(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-promotion-controls"] && !Shopify.designMode) return;
  try {
    function initializePromotionControls(grid) {
  const root=grid.closest('.pp-shopping-content');
  const controls=root.querySelector('[data-promo-controls]');
  if(!controls||controls.dataset.initialized)return;
  controls.dataset.initialized='true';
  const form=controls.querySelector('form');
  const author=form.elements.promo_author;
  const format=form.elements.promo_format;
  const sort=form.elements.promo_sort_by;
  const cards=[...grid.children];
  const apply=updateUrl=>{
    const ordered=[...cards];
    if(sort.value==='title-ascending')ordered.sort((a,b)=>a.dataset.promoTitle.localeCompare(b.dataset.promoTitle));
    if(sort.value==='title-descending')ordered.sort((a,b)=>b.dataset.promoTitle.localeCompare(a.dataset.promoTitle));
    let shown=0;
    ordered.forEach(card=>{
      card.hidden=(author.value!==''&&card.dataset.promoAuthor!==author.value)||(format.value!==''&&card.dataset.promoFormat!==format.value);
      if(!card.hidden)shown++;
      grid.appendChild(card);
    });
    controls.querySelector('[data-promo-count]').textContent=controls.dataset.countTemplate.replace('__shown__',shown).replace('__total__',cards.length);
    if(updateUrl){
      const url=new URL(location.href);
      ['promo_author','promo_format','promo_sort_by'].forEach(key=>url.searchParams.delete(key));
      if(author.value)url.searchParams.set(author.name,author.value);
      if(format.value)url.searchParams.set(format.name,format.value);
      if(sort.value!=='manual')url.searchParams.set(sort.name,sort.value);
      url.hash='all-products';history.replaceState(null,'',url);
    }
  };
  const readUrl=()=>{
    const params=new URLSearchParams(location.search);
    [author,format,sort].forEach(select=>{
      const value=params.get(select.name);
      select.value=[...select.options].some(option=>option.value===value)?value:select.options[0].value;
    });
  };
  form.querySelector('button').disabled=false;
  form.addEventListener('submit',event=>{event.preventDefault();apply(true);});
  controls.querySelector('[data-promo-reset]').addEventListener('click',event=>{event.preventDefault();form.reset();apply(true);});
  window.addEventListener('popstate',()=>{readUrl();apply(false);});
  readUrl();apply(false);
}
document.addEventListener('pp:promotions-ready',event=>initializePromotionControls(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-rotating-products"] && !Shopify.designMode) return;
  try {
    function rotatePenProducts(){
document.querySelectorAll('[data-rotating-products]').forEach(section=>{
const grid=section.querySelector('[data-rotating-grid]');
const cards=Array.from(grid.querySelectorAll('[data-rotating-card]'));
for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
cards.forEach((card,index)=>{card.hidden=index>=3;grid.appendChild(card);});
});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',rotatePenProducts);}else{rotatePenProducts();}
document.addEventListener('shopify:section:load',rotatePenProducts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["positive-pen-shop-navigation"] && !Shopify.designMode) return;
  try {
    function initializePenShop(root) {
  root.querySelectorAll('[data-pp-shop-tools]').forEach(tools => {
    if (tools.dataset.initialized) return;
    tools.dataset.initialized = 'true';
    const mobile = tools.querySelector('[data-shop-mobile]');
    const groups = [...tools.querySelectorAll('.pp-shop-group')];
    const desktop = window.matchMedia('(min-width:990px)');
    const reset = () => {
      mobile.open = desktop.matches;
      groups.forEach(group => group.open = false);
    };
    reset();
    desktop.addEventListener('change', reset);
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    }));
    tools.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const group = groups.find(item => item.open);
      if (group) { group.open = false; group.querySelector('summary').focus(); }
      else if (!desktop.matches && mobile.open) { mobile.open = false; mobile.querySelector('summary').focus(); }
    });
    document.addEventListener('click', event => {
      if (tools.contains(event.target)) return;
      groups.forEach(group => group.open = false);
      if (!desktop.matches) mobile.open = false;
    });
  });
}
initializePenShop(document);
document.addEventListener('shopify:section:load', event => initializePenShop(event.target));
  } catch(e) { console.error(e); }
})();

})();
